const cookielaw = (beneficiaryData) => {

  if ( beneficiaryData.urlOneTrust ) {
    var element = document.getElementById("find-me");
    if ( typeof(element) == 'undefined' || element == null ) {
      fetchJsFromCDN(beneficiaryData.urlOneTrust);
    }
  }
}

const fetchJsFromCDN = (oneTrustKey, externals = []) => {
  
	 new Promise((resolve, reject) => {
	   
		const script = document.createElement('script')
				
		script.id = "find-me";
    	script.setAttribute('src', 'https://cdn.cookielaw.org/consent/'+oneTrustKey+'/OtAutoBlock.js');
	  	script.setAttribute('type', 'text/javascript');
	
    	script.addEventListener('load', () => {
      	resolve(externals.map(key => {
        	const ext = window[key]
        	typeof ext === 'undefined' && console.warn(`No external named '${key}' in window`)
        	return ext
      		}))
    	})
    	script.addEventListener('error', reject);
    	( document.getElementsByTagName("head")[0] || document.documentElement ).appendChild(script);		
	});
	
	new Promise((resolve, reject) => {
	    const script = document.createElement('script')
	  
	    script.id = "find-me";
	    script.setAttribute('src', 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js');
		script.setAttribute('type', 'text/javascript');
		script.setAttribute('charset', 'UTF-8');
	    script.setAttribute('data-domain-script', oneTrustKey);
		
	    script.addEventListener('load', () => {
	      resolve(externals.map(key => {
	        const ext = window[key]
	        typeof ext === 'undefined' && console.warn(`No external named '${key}' in window`)
	        return ext
	      }))
	    })
	    script.addEventListener('error', reject);
	    ( document.getElementsByTagName("head")[0] || document.documentElement ).appendChild(script);
  	});
}

export default cookielaw;


// WEBPACK FOOTER //
// ./src/utils/cookielaw.js